<gp-modal [closable]="true" size="xl">
  <div class="gp-modal-title">
      <h4 class="text-ellipsis">
          {{ 'SETTINGS.user_rights.manage_entity_access_criterion' | translate }}
      </h4>
  </div>
  <div class="gp-modal-body criterionList">
    <div *ngIf="showConfirmDeletionMessage" id="confirmDeleteMessage"
         class="alert flex-center-x-y p-y-sm confirm-deletion-alert">
      <h6 class="m-y-0">
        <em class="fa-duotone fa-diamond-exclamation p-r-sm"></em>
        {{ 'SETTINGS.user_rights.access_criterion_deleted_confirmation_msg' | translate }}
      </h6>
      <div>
        <button (click)="handleDeleteCriterionConfirmation()"
                [disabled]="isOperationInProgress"
                class="btn btn-sm btn-danger p-x-md m-l-md m-r-sm" test-id="confirmButton" type="button">
          <em *ngIf="isOperationInProgress" class="fa fa-light fa-spinner"></em>
          {{ 'FORMS.confirm' | translate }}
        </button>
        <button (click)="discardDeleteCriterion()"
                [disabled]="isOperationInProgress"
                class="btn btn-sm btn-secondary p-x-md" test-id="cancelButton" type="button">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>
    <div class="box-body table-responsive">
      <form [formGroup]="manageEntityAccessCriterionForm" class="gp-modal-body clearfix" novalidate>
        <div class="row form-group flex-center-x-y light p-y-xs">
          <div class="col-md-4 text-right">
            <label class="font-weight-bold m-y-0"
                   for="entityTreeName">{{'SETTINGS.user_rights.entity_tree_name' | translate }}
              <span class="required"> *</span>
            </label>
          </div>
          <div class="col-md-3">
              <ng-select
                      (removed)="removeSelectedTreeName()"
                      (selected)="selectEntityTreeName($event)"
                      [allowClear]="true"
                      [attr.test-id]="'entityTreeName'"
                      [disabled]="isAddOrUpdateActive || isDeleteCriterionActive"
                      [items]="entityTreeNameItems"
                      [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                      class="form-control"
                      formControlName="entityTreeName"
                      id="entityTreeName">
            </ng-select>
          </div>
          <div class="col-md-4">
            <button (click)="showAddCriterionFormFields()"
                    [disabled]="isInitialState || isContentLoading || isAddOrUpdateActive || isDeleteCriterionActive"
                    class="btn btn-sm btn-primary p-x-md"
                    type="button">
              {{'SETTINGS.user_rights.create_new_criterion' | translate}}
            </button>
          </div>
        </div>
      </form>
      <gp-illustrated-message *ngIf="isInitialState; else entityTreeTableContent"
                              [text]="'SETTINGS.user_rights.manage_entity_access_criterion_instruction'"
                              [width]="'40%'">
      </gp-illustrated-message>
      <ng-template #entityTreeTableContent>
        <form [formGroup]="entityCriterionForm" class="table-wrapper" novalidate>
          <table aria-describedby="entityTreeCriterionList"
                 class="table table-striped gp-table" id="entityTreeCriterionList">
            <thead>
            <tr class="text-uppercase text-xs" role="row">
              <th class="p-y-0 w-160"
                  scope="col" test-id="entity-type">
                {{ 'SETTINGS.entity_type' | translate }}
                <span *ngIf="isAddOrUpdateActive" class="required"> *</span>
              </th>
              <th class="p-y-0 w-64"
                  scope="col" test-id="full-access">
                {{ 'SETTINGS.full_access' | translate }}
              </th>
              <th class="p-y-0 w-xl max-width-xl"
                  scope="col" test-id="group-zone-name">
                {{ 'SETTINGS.group_zone_name' | translate }}
                <span *ngIf="isAddOrUpdateActive && !fullAccessChecked" class="required"> *</span>
              </th>
              <th class="p-y-0 w-xl max-width-xl"
                  scope="col" test-id="zone-name">
                {{ 'SETTINGS.zone_name' | translate }}
                <span *ngIf="isAddOrUpdateActive && !fullAccessChecked" class="required"> *</span>
              </th>
              <th class="p-y-0 w-xs"
                  scope="col" test-id="zone-type">
                {{ 'SETTINGS.zone_type' | translate }}
              </th>
              <th class="p-y-0 w"
                  scope="col" test-id="zone-value">
                {{ 'FORMS.Value' | translate }}
                <span *ngIf="isAddOrUpdateActive && !fullAccessChecked" class="required"> *</span>
              </th>
              <th class="p-y-0 w-sm" scope="col" test-id="header-access-mode">
                {{ 'SETTINGS.access_mode' | translate }}
                <span *ngIf="isAddOrUpdateActive" class="required"> *</span>
              </th>
              <th class="p-y-0 w-xs" scope="col" test-id="header-actions">
                {{ 'MDU.actions' | translate }}
              </th>
            </tr>
            </thead>
            <tbody class="table-body">
            <tr *ngIf="isContentLoading" id="loader">
              <td [attr.colspan]="9" class="text-center p-y-lg">
                <em class="fa fa-light fa-spinner fa-spin"></em>
              </td>
            </tr>
            <ng-container *ngIf="isContentLoaded || isAddOrUpdateActive || isDeleteCriterionActive">
              <tr *ngIf="isAddCriterionActive" class="row" role="row">
                <td class="w-160">
                  <ng-select [attr.test-id]="'entityType'"
                             (removed)="removeSelectedEntityType()"
                             (selected)="selectEntityType($event)"
                             [disabled]="!isAddCriterionActive || isOperationInProgress"
                             [items]="entityTypeList"
                             [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                             class="form-control"
                             formControlName="entityType"
                             id="entityType">
                  </ng-select>
                </td>
                <td class="w-64">
                  <div class="flex-center-x-y">
                  <label class="ui-switch full-access-switch m-l-xs">
                    <input type="checkbox"
                           (click)="onFullAccessChecked($event.target)"
                           [checked]="fullAccessChecked"
                           [attr.test-id]="'addFullAccess'"
                           formControlName="fullAccess"
                           id="addFullAccess">
                    <em></em>
                  </label>
                  </div>
                </td>
                <td class="w-xl max-width-xl">
                  <gp-tree-select
                    [attr.test-id]="'groupZoneName'"
                    [isSorted]="true"
                    [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                    [tree]="groupZoneNameTree"
                    (elementSelected)="selectGroupZoneName($event)"
                    [readOnly]="!isAddCriterionActive || isOperationInProgress || fullAccessChecked"
                    class="form-control"
                    formControlName="groupZoneName"
                    id="groupZoneName"
                    ngDefaultControl>
                  </gp-tree-select>
                </td>
                <td class="w-xl max-width-xl">
                  <gp-tree-select
                    [attr.test-id]="'zoneName'"
                    [isSorted]="true"
                    [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                    [tree]="zoneNameTree"
                    (elementSelected)="selectZoneName($event)"
                    [readOnly]="!isAddCriterionActive || isOperationInProgress || fullAccessChecked"
                    class="form-control"
                    formControlName="zoneName"
                    id="zoneName"
                    ngDefaultControl>
                  </gp-tree-select>
                </td>
                <td class="w-xs">
                  {{ selectedZoneType?.length ? selectedZoneType : '-' }}
                </td>
                <td class="w">
                  <ng-container [ngSwitch]="selectedZoneType">
                    <gp-tree-select *ngSwitchCase="'LIST'"
                                    [attr.test-id]="'criteriaValue'"
                                    [isSorted]="true"
                                    [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                                    [tree]="selectedZoneMetadata"
                                    [readOnly]="!isAddCriterionActive || isOperationInProgress || fullAccessChecked"
                                    (elementSelected)="selectZoneValue($event)"
                                    class="form-control"
                                    formControlName="value"
                                    id="valueList"
                                    ngDefaultControl>
                    </gp-tree-select>

                    <gp-tree-select *ngSwitchCase="'TREE'"
                                    [attr.test-id]="'criteriaValue'"
                                    [isSorted]="true"
                                    [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                                    [tree]="selectedZoneMetadata"
                                    [readOnly]="!isAddCriterionActive || isOperationInProgress || fullAccessChecked"
                                    (elementSelected)="selectZoneValue($event)"
                                    class="form-control"
                                    formControlName="value"
                                    id="valueTree"
                                    ngDefaultControl>
                    </gp-tree-select>

                    <ng-container *ngSwitchCase="'ENTITY'">
                      <gp-tree-select
                        *ngIf="selectedZoneMetadata"
                        class="form-control"
                        [attr.test-id]="'criteriaValue'"
                        [url]="selectedZoneMetadata"
                        [responseCallBack]="responseCallback"
                        [lazyValue]="lazyValue"
                        [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                        [isSorted]="true"
                        [readOnly]="!isAddCriterionActive || isOperationInProgress || fullAccessChecked"
                        (elementSelected)="selectZoneValue($event)"
                        formControlName="value"
                        id="valueEntity"
                        ngDefaultControl>
                      </gp-tree-select>
                    </ng-container>

                    <datepicker-input *ngSwitchCase="'DATE'"
                                      [attr.test-id]="'criteriaValue'"
                                      [isAppendToBody]="false"
                                      [readOnly]="!isAddCriterionActive || isOperationInProgress || fullAccessChecked"
                                      id="valueDate"
                                      formControlName="value"
                                      ngDefaultControl>
                    </datepicker-input>

                    <div *ngSwitchCase="'BOOLEAN'">
                      <label class="ui-switch full-access-switch m-l-xs">
                        <input type="checkbox"
                               [attr.test-id]="'editCriteriaValue'"
                               [checked]=booleanValueChecked
                               formControlName="value"
                               id="valueBoolean">
                        <em></em>
                      </label>
                    </div>

                    <input *ngSwitchDefault
                           [attr.test-id]="'criteriaValue'"
                           [placeholder]="'SETTINGS.user_rights.placeholder_criterion_value' | translate"
                           [readOnly]="!isAddCriterionActive || isOperationInProgress || fullAccessChecked"
                           class="form-control"
                           formControlName="value"
                           id="value"
                           type="text"/>
                  </ng-container>
                  <ul
                    [attr.data-hidden]="entityCriterionForm.controls.value.valid || entityCriterionForm.controls.value.pristine"
                    class="error-list">
                    <li *ngIf="entityCriterionForm.controls.value.errors?.maxlength">
                      {{ 'FORMS.VALIDATORS.maxlength' | translate: {length: MAX_ALLOWED_LENGTH} }}
                    </li>
                  </ul>
                </td>
                <td class="w-xs">
                  <ng-select [attr.test-id]="'accessMode'"
                             [disabled]="!isAddCriterionActive || isOperationInProgress"
                             [items]="accessModes"
                             [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                             class="form-control"
                             formControlName="accessMode"
                             id="inputAccessMode">
                  </ng-select>
                </td>
                <td class="flex-center-x-y w-auto">
                  <button (click)="createEntityAccessCriterion()"
                          [disabled]="entityCriterionForm?.invalid || isOperationInProgress"
                          [tooltip]="'FORMS.save' | translate"
                          class="btn btn-xs text-white btn-primary" type="button">
                    <em *ngIf="!isOperationInProgress" class="fa fa-light fa-check"></em>
                    <em *ngIf="isOperationInProgress" class="fa fa-light fa-spinner"></em>
                  </button>
                  <button (click)="hideAddOrUpdateForm(entityCriterionForm)" [disabled]="!isAddCriterionActive"
                          [tooltip]="'FORMS.cancel' | translate"
                          class="btn btn-xs btn-default" type="button">
                    <em class="fa fa-light fa-times"></em>
                  </button>
                </td>
              </tr>
              <tr *ngFor="let criterion of criterionDataByTreeName trackBy: trackByCriterionId"
                  [class.highlight]="criterion?.id === criterionToBeDeleted">
                <ng-container *ngIf="(criterion?.id !== criterionToBeUpdated); else showEditableRow">
                  <td class="wrap w-160">{{ criterion.entityType }}</td>
                  <td class="w-64">
                    <div class="availability-status">
                    <span>
                      <i
                        [attr.test-id]="'template-availability-types'"
                        [ngClass]="(criterion.groupZoneName==null) ? 'fa-check' : 'fa-minus not-available'"
                        aria-hidden="true"
                        class="fa fa-light p-a-xs">
                      </i>
                    </span>
                    </div>
                  </td>
                  <td
                    class="wrap w-xl max-width-xl">{{ criterion.groupZoneName != null ? criterion.groupZoneName : '-' }}
                  </td>
                  <td class="wrap w-xl max-width-xl">{{ criterion.zoneName != null ? criterion.zoneName : '-' }}</td>
                  <td class="w-xs">{{ criterion.value != null ? criterion.value[criterion?.zoneName]?.type : '-' }}</td>
                  <td
                    class="wrap w">
                    <ng-container *ngIf="checkCriterionValue(criterion); else readableName">
                      <em class="fa fa-light"
                          [ngClass] = "checkBooleanValue(criterion) ? 'fa-check' : 'fa fa-light fa-times'">
                      </em>
                    </ng-container>
                    <ng-template #readableName>
                      {{ getReadableName(criterion)}}
                    </ng-template>
                  </td>
                  <td class="w-xs">{{ criterion?.access }}</td>
                  <td class="w-xs">
                    <button (click)="updateCriterion(criterion)"
                            [disabled]="isAddOrUpdateActive || isDeleteCriterionActive"
                            class="btn btn-xs btn-default"
                            test-id="action-update-criterion"
                            tooltip="{{'TOOLTIPS.edit' | translate}}" type="button">
                      <em class="fa fa-light fa-pencil-alt"></em>
                    </button>
                    <button (click)="deleteCriterion(criterion?.id)"
                            [disabled]="isAddOrUpdateActive || isDeleteCriterionActive"
                            class="btn btn-xs btn-outline-danger"
                            test-id="action-delete-criterion"
                            tooltip="{{'TOOLTIPS.delete' | translate}}" type="button">
                      <em class="fa fa-light fa-trash-alt"></em>
                    </button>
                  </td>
                </ng-container>
                <ng-template #showEditableRow>
                  <td class="w-160">
                    <ng-select [attr.test-id]="'editEntityType'"
                               (removed)="removeSelectedEntityType()"
                               (selected)="selectEntityType($event)"
                               [items]="entityTypeList"
                               [disabled]="isOperationInProgress"
                               [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                               class="form-control text-center"
                               formControlName="entityType"
                               id="editEntityType">
                    </ng-select>
                  </td>
                  <td class="w-64">
                    <div class="flex-center-x-y">
                    <label class="ui-switch full-access-switch m-l-xs">
                      <input type="checkbox"
                             (click)="onFullAccessChecked($event.target)"
                             [checked]="fullAccessChecked"
                             [attr.test-id]="'editFullAccess'"
                             formControlName="fullAccess"
                             id="editFullAccess">
                      <em></em>
                    </label>
                    </div>
                  </td>
                  <td class="w-xl max-width-xl">
                    <gp-tree-select
                      [attr.test-id]="'editGroupZoneName'"
                      [isSorted]="true"
                      [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                      [tree]="groupZoneNameTree"
                      (elementSelected)="selectGroupZoneName($event)"
                      [readOnly]="isOperationInProgress || fullAccessChecked"
                      class="form-control"
                      formControlName="groupZoneName"
                      id="editGroupZoneName"
                      ngDefaultControl>
                    </gp-tree-select>
                    <ul
                      [attr.data-hidden]="entityCriterionForm.controls.groupZoneName.valid || entityCriterionForm.controls.groupZoneName.pristine"
                      class="error-list">
                      <li *ngIf="entityCriterionForm.controls.groupZoneName.errors?.maxlength">
                        {{ 'FORMS.VALIDATORS.maxlength' | translate: {length: MAX_ALLOWED_LENGTH} }}
                      </li>
                    </ul>
                  </td>
                  <td class="w-xl max-width-xl">
                    <gp-tree-select
                      [attr.test-id]="'editZoneName'"
                      [isSorted]="true"
                      [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                      [tree]="zoneNameTree"
                      (elementSelected)="selectZoneName($event)"
                      [readOnly]="isOperationInProgress || fullAccessChecked"
                      class="form-control"
                      formControlName="zoneName"
                      id="editZoneName"
                      ngDefaultControl>
                    </gp-tree-select>
                    <ul
                      [attr.data-hidden]="entityCriterionForm.controls.zoneName.valid || entityCriterionForm.controls.zoneName.pristine"
                      class="error-list">
                      <li *ngIf="entityCriterionForm.controls.zoneName.errors?.maxlength">
                        {{ 'FORMS.VALIDATORS.maxlength' | translate: {length: MAX_ALLOWED_LENGTH} }}
                      </li>
                    </ul>
                  </td>
                  <td class="w-xs">
                    {{ selectedZoneType?.length ? selectedZoneType : '-' }}
                  </td>
                  <td class="w">
                    <ng-container [ngSwitch]="selectedZoneType">
                      <gp-tree-select *ngSwitchCase="'LIST'"
                                      [attr.test-id]="'editCriteriaValue'"
                                      [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                                      [tree]="selectedZoneMetadata"
                                      [isSorted]="true"
                                      [readOnly]="isOperationInProgress || fullAccessChecked"
                                      (elementSelected)="selectZoneValue($event)"
                                      class="form-control"
                                      formControlName="value"
                                      id="editValueList"
                                      ngDefaultControl>
                      </gp-tree-select>

                      <gp-tree-select *ngSwitchCase="'TREE'"
                                      [attr.test-id]="'editCriteriaValue'"
                                      [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                                      [tree]="selectedZoneMetadata"
                                      [isSorted]="true"
                                      [readOnly]="isOperationInProgress || fullAccessChecked"
                                      (elementSelected)="selectZoneValue($event)"
                                      class="form-control"
                                      formControlName="value"
                                      id="editValueTree"
                                      ngDefaultControl>
                      </gp-tree-select>
                      <ng-container *ngSwitchCase="'ENTITY'">
                        <gp-tree-select
                          *ngIf="selectedZoneMetadata"
                          class="form-control"
                          [attr.test-id]="'editCriteriaValue'"
                          [url]="selectedZoneMetadata"
                          [responseCallBack]="responseCallback"
                          [lazyValue]="lazyValue"
                          [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                          formControlName="value"
                          [isSorted]="true"
                          [readOnly]="isOperationInProgress || fullAccessChecked"
                          (elementSelected)="selectZoneValue($event)"
                          ngDefaultControl>
                        </gp-tree-select>
                      </ng-container>

                      <datepicker-input *ngSwitchCase="'DATE'"
                                        [attr.test-id]="'editCriteriaValue'"
                                        [isAppendToBody]="false"
                                        [readOnly]="isOperationInProgress || fullAccessChecked"
                                        id="editValueDate"
                                        formControlName="value"
                                        ngDefaultControl>
                      </datepicker-input>

                      <div *ngSwitchCase="'BOOLEAN'">
                        <label class="ui-switch full-access-switch m-l-xs">
                          <input type="checkbox"
                                 [attr.test-id]="'editCriteriaValue'"
                                 [checked]="booleanValueChecked"
                                 formControlName="value"
                                 id="editValueBoolean">
                          <em></em>
                        </label>
                      </div>

                      <input *ngSwitchDefault
                             [attr.test-id]="'editCriteriaValue'"
                             [placeholder]="'SETTINGS.user_rights.placeholder_criterion_value' | translate"
                             [readOnly]="isOperationInProgress || fullAccessChecked"
                             class="form-control text-center"
                             formControlName="value"
                             id="editCriteriaValue"
                             type="text"/>
                    </ng-container>
                    <ul
                      [attr.data-hidden]="entityCriterionForm.controls.value.valid || entityCriterionForm.controls.value.pristine"
                      class="error-list">
                      <li *ngIf="entityCriterionForm.controls.value.errors?.maxlength">
                        {{ 'FORMS.VALIDATORS.maxlength' | translate: {length: MAX_ALLOWED_LENGTH} }}
                      </li>
                    </ul>
                  </td>
                  <td class="w-xs">
                    <ng-select [attr.test-id]="'editAccessMode'"
                               [items]="accessModes"
                               [placeholder]="'EMPLOYEE_HIRE.select' | translate"
                               [disabled]="isOperationInProgress"
                               class="form-control text-center"
                               formControlName="accessMode"
                               id="editAccessMode">
                    </ng-select>
                  </td>
                  <td class="w-xs">
                    <button (click)="updateEntityAccessCriterion()"
                            [disabled]="entityCriterionForm?.invalid || isOperationInProgress"
                            [tooltip]="'FORMS.save' | translate"
                            class="btn btn-xs text-white btn-primary"
                            id="saveUpdate" type="button">
                      <em *ngIf="!isOperationInProgress" class="fa fa-light fa-check"></em>
                      <em *ngIf="isOperationInProgress" class="fa fa-light fa-spinner"></em>
                    </button>
                    <button (click)="hideAddOrUpdateForm(entityCriterionForm)"
                            [disabled]="!isUpdateCriterionActive || isOperationInProgress"
                            [tooltip]="'FORMS.cancel' | translate"
                            class="btn btn-xs btn-default"
                            id="cancelUpdate" type="button">
                      <em class="fa fa-light fa-times"></em>
                    </button>
                  </td>
                </ng-template>
              </tr>
            </ng-container>
            </tbody>
          </table>
          <ng-container *ngIf="isCriterionNotFound" test-id="criterion-not-found-message">
            <gp-illustrated-message [text]="'SETTINGS.user_rights.criterion_not_found'"
                                    [width]="'40%'">
            </gp-illustrated-message>
          </ng-container>
        </form>
        <gp-table-pagination
          (pageChange)="pageChanged()"
          [pagination]="pagination"
          [text]="'SETTINGS.user_rights.showing___of_entity_access_criterion'">
        </gp-table-pagination>
      </ng-template>
    </div>
  </div>
  <div class="gp-modal-footer"></div>
</gp-modal>
